import '@fortawesome/fontawesome-free/css/all.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import Vue from 'vue';

import fb from './api/firebaseConfig';

import App    from './App.vue';

import './plugins/vuetify';
import router from './router';
import store  from './store';

Vue.config.productionTip = false;

// handle page reloads
let app: any;
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
